var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('settings-customer-default-group',{model:{value:(_vm.defaultGroup),callback:function ($$v) {_vm.defaultGroup=$$v},expression:"defaultGroup"}})}
var staticRenderFns = []

export { render, staticRenderFns }